import React from 'react'
import { useSelector } from 'react-redux'
import { PulseLoader } from 'react-spinners'
import '../../../src/App.css'

export default function ButtonLoader({ login }) {
    const userDetails = useSelector(state => state?.login)    
    return (
        <button
            type='button'
            disabled
            className={`tracking-wider font-tbPop rounded-md ${userDetails?.isLoggedIn == true ? 'bg-base-color' : 'bg-base-color-blue'} px-3 py-2.5 text-base font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${login ? "w-full" : "w-auto"
                }`}
        >
            Loading<span><PulseLoader color="#fff" size={5} /></span>
        </button>
    )
}
